/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import ReactDOM from 'react-dom';
import { Routes } from 'react-router';

import { ErrorBoundary, SkipNavContent, useFlags } from 'sarsaparilla';
import { Footer } from 'site-kit';

import { ExternalPageFrame } from 'shared-ui/external-app-base';
import ErrorPage from 'shared-ui/components/ErrorPage/ErrorPage';
import { TopNavigationExternal } from 'shared-ui/TopNavigationExternal';

import makeSwitchRoutes from './makeSwitchRoutes';

export default function App() {
    const { releaseDigitalIapFeatures } = useFlags();
    const releaseIapPassLandingPage = releaseDigitalIapFeatures?.passLandingPage;

    return (
        <ExternalPageFrame>
            <TopNavigationExternal />

            <ErrorBoundary fallbackElement={<ErrorPage />}>
                <SkipNavContent className="rec-page" role="main">
                    <Routes>{makeSwitchRoutes(releaseIapPassLandingPage)}</Routes>
                </SkipNavContent>
            </ErrorBoundary>

            <Footer />
        </ExternalPageFrame>
    );
}
